/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Voice_TitleInputs */

const en_onboarding_voice_title = /** @type {(inputs: Onboarding_Voice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Voice`)
};

const es_onboarding_voice_title = /** @type {(inputs: Onboarding_Voice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz de IA`)
};

/**
* | output |
* | --- |
* | "AI Voice" |
*
* @param {Onboarding_Voice_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_voice_title = /** @type {((inputs?: Onboarding_Voice_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Voice_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_voice_title(inputs)
	return en_onboarding_voice_title(inputs)
});